module.exports = __webpack_public_path__ + "static/media/rapidNaming-intro3.053860a8.mp3";